module.exports = __webpack_public_path__ + "img/bar.31229d1b.png";